import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=413db995&scoped=true&lang=pug&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&id=413db995&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413db995",
  null
  
)

export default component.exports